export default __webpack_public_path__ + "static/media/nfo_postlogin_arbitage_banner_mob.6a082e56.png";